<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">
                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{'Date range'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date</mat-label>
                                            <input matInput formControlName="start" [matDatepicker]="picker"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>End date</mat-label>
                                            <input matInput formControlName="end" [matDatepicker]="picker2"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>

                                        <div class="pb-24 font-size-18 font-weight-300">
                                            <button (click)="today()" mat-raised-button class="mr-8"
                                                    color="accent">{{'Today'|translate}}</button>
                                            <button (click)="yesterday()" mat-raised-button class="mr-8"
                                                    color="accent">{{'Yesterday'|translate}}</button>
                                            <button (click)="lastWeek()" mat-raised-button class="mr-8"
                                                    color="accent">{{'Last week'|translate}}</button>
                                            <button (click)="lastMonth()" mat-raised-button class="mr-8"
                                                    color="accent">{{'Last month'|translate}}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">
                        <div class="p-16" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16 table">
                                <div class="h2 secondary-text">{{'The report data by time period'|translate}} {{fromDate}}
                                    - {{toDate}}</div>


                                <table>
                                    <tbody>
                                    <tr *ngFor="let item of countedWorkTime">
                                        <th style="text-align: left;">{{item.firstName}} {{item.lastName}}
                                            ({{item.username}})
                                        </th>
                                        <td>
                                            <a style="cursor: pointer;"
                                               (click)="showWorkTimeDetailsDialog(item.userId, item.detailsDate, item.detailsDate)">{{item.totalInString}}
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
